<div class="grid-container grid-page">
  <form #form="ngForm">
    <div class="filter-container filter row">
      <div class="form-group col-lg-2 col-md-3 col-sm-6">
        <label>From</label>
        <kendo-datetimepicker
          [readonly]="filterLoading"
          class="umj-datepicker-sm"
          [(ngModel)]="filter.Start"
          [focusedDate]="filter.Start"
          style="width: 100%"
          #fromDate="ngModel"
          name="fromDate"
          required
        >
        </kendo-datetimepicker>
      </div>
      <div class="form-group col-lg-2 col-md-3 col-sm-6">
        <label>To</label>
        <kendo-datetimepicker
          class="umj-datepicker-sm"
          [readonly]="filterLoading"
          [(ngModel)]="filter.End"
          [focusedDate]="filter.End"
          style="width: 100%"
          #toDate="ngModel"
          name="toDate"
          required
        >
        </kendo-datetimepicker>
      </div>

      <div class="form-group col-lg-2 col-md-3 col-sm-6" *ngIf="contactsEnabled">
        <label>Contact</label>
        <kendo-dropdownlist
          [data]="filteredContacts"
          [(value)]="filter.ContactId"
          [filterable]="true"
          (filterChange)="handleContactsFilter($event)"
          [textField]="'Name'"
          [valueField]="'Id'"
          [defaultItem]="{ Id: null, Name: 'Select contact...' }"
          class="form-control-sm dropdown-block"
          [disabled]="filterLoading"
          [valuePrimitive]="true"
          style="width: 100%"
        >
        </kendo-dropdownlist>
      </div>

      <div class="form-group col-lg-2 col-md-3 col-sm-6" *ngIf="locationsEnabled">
        <label>Location</label>
        <kendo-dropdownlist
          [data]="filteredLocations"
          [(value)]="filter.LocationId"
          [filterable]="true"
          (filterChange)="handleLocationsFilter($event)"
          [textField]="'LotName'"
          [valueField]="'Id'"
          [defaultItem]="{ Id: null, LotName: 'Select location...' }"
          class="form-control-sm dropdown-block"
          [disabled]="filterLoading"
          [valuePrimitive]="true"
          style="width: 100%"
        >
        </kendo-dropdownlist>
      </div>

      <div class="form-group col-lg-2 col-md-3 col-sm-6">
        <label>Template</label>
        <kendo-dropdownlist
          [data]="templates"
          [(ngModel)]="filter.TemplateId"
          [filterable]="true"
          [textField]="'Name'"
          [valueField]="'Id'"
          [defaultItem]="{ Id: null, Name: 'Select template...' }"
          class="form-control-sm dropdown-block"
          [disabled]="filterLoading"
          [valuePrimitive]="true"
          style="width: 100%"
          name="templateId"
        >
        </kendo-dropdownlist>
      </div>

      <div class="form-group col-lg-1 col-md-2 col-sm-6">
        <label>Incident Id</label>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="filter.IncidentId"
          [disabled]="filterLoading"
          style="height: 30px"
          name="incidentId"
        />
      </div>

      <div class="form-group col-lg-1 col-md-2 col-sm-6" style='padding: 0;'>
        <div style="white-space: nowrap">
          <button class="button ND--buttons--second-button btn-search" [disabled]="filterLoading || form.invalid" (click)="resetFilter()">
            Reset
          </button>
          <button class="button ND--buttons--primary btn-search" [disabled]="filterLoading || form.invalid" (click)="search()">
            Select
          </button>
        </div>
      </div>
    </div>
  </form>

  <div class="activity-grid kendo-grid-bordered" #qaGridContainer>
    <kendo-grid
      [data]="view | async"
      [pageSize]="state.take"
      [skip]="state.skip"
      [sort]="state.sort"
      [sortable]="{ mode: 'multiple' }"
      [height]="300"
      [pageable]="true"
      [groupable]="false"
      [rowClass]="rowCallback.bind(this)"
      [selectable]="true"
      (dataStateChange)="dataStateChange($event)"
      (excelExport)="excelExport($event)"
      [filterable]="'menu'"
      [filter]="state.filter"
      (selectionChange)="rowSelectionChange($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        <button kendoGridExcelCommand><span class="k-icon k-i-file-excel"></span>Export to Excel</button>
      </ng-template>

      <kendo-grid-excel [fileName]="excelFileName">
        <kendo-excelexport-column title="Incident ID" field="fkIncident" [cellOptions]="cells"> </kendo-excelexport-column>
        <kendo-excelexport-column title="Created" field="Created" [cellOptions]="cells"></kendo-excelexport-column>
        <kendo-excelexport-column title="Contact" field="fkContact" [hidden]="!contactsEnabled" [cellOptions]="cells">
        </kendo-excelexport-column>
      </kendo-grid-excel>

      <kendo-grid-column title="Incident ID" field="fkIncident" filter="numeric" format="{0:n0}" width="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          <app-template-link-copy-wrapper
            [href]="
              originUrl +
              '/#/activity/qa/' +
              dataItem?.fkIncident +
              '/quality' +
              (filter.TemplateId ? '?templateId=' + filter.TemplateId : '')
            "
            [isStatic]="true"
          >
            {{ dataItem.fkIncident }}
          </app-template-link-copy-wrapper>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Created" field="Created" width="120" [filterable]="false">
        <ng-template kendoGridGroupHeaderTemplate let-group let-field="field" let-dataItem let-value="value">
          <app-template-link-copy-wrapper
            [href]="
              originUrl +
              '/#/activity/qa/' +
              dataItem?.fkIncident +
              '/quality' +
              (filter.TemplateId ? '?templateId=' + filter.TemplateId : '')
            "
            [isStatic]="true"
          >
            Date: {{ value | kendoDate: 'MMM d hh:mm:ss a' }}
          </app-template-link-copy-wrapper>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <app-template-link-copy-wrapper
            [href]="
              originUrl +
              '/#/activity/qa/' +
              dataItem?.fkIncident +
              '/quality' +
              (filter.TemplateId ? '?templateId=' + filter.TemplateId : '')
            "
            [isStatic]="true"
          >
            {{ dataItem.Created | kendoDate: 'MMM d hh:mm:ss a' }}
          </app-template-link-copy-wrapper>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Call Time" field="CallTime" width="120" [filterable]="false">
        <ng-template kendoGridGroupHeaderTemplate let-dataItem let-group let-field="field" let-value="value">
          <app-template-link-copy-wrapper
            [href]="
              originUrl +
              '/#/activity/qa/' +
              dataItem?.fkIncident +
              '/quality' +
              (filter.TemplateId ? '?templateId=' + filter.TemplateId : '')
            "
            [isStatic]="true"
          >
            Call Time Date: {{ value | kendoDate: 'MMM d hh:mm:ss a' }}
          </app-template-link-copy-wrapper>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <app-template-link-copy-wrapper
            [href]="
              originUrl +
              '/#/activity/qa/' +
              dataItem?.fkIncident +
              '/quality' +
              (filter.TemplateId ? '?templateId=' + filter.TemplateId : '')
            "
            [isStatic]="true"
          >
            {{ dataItem.CallTime | kendoDate: 'MMM d hh:mm:ss a' }}
          </app-template-link-copy-wrapper>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Contact" field="fkAgent" [hidden]="!contactsEnabled" width="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          <app-template-link-copy-wrapper
            [href]="
              originUrl +
              '/#/activity/qa/' +
              dataItem?.fkIncident +
              '/quality' +
              (filter.TemplateId ? '?templateId=' + filter.TemplateId : '')
            "
            [isStatic]="true"
          >
            {{ creatorName(dataItem.fkAgent) }}
          </app-template-link-copy-wrapper>
        </ng-template>

        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
          <kendo-multiselect
            [data]="contacts"
            [value]="selectedContact"
            (valueChange)="multiSelectValueChange($event, column.field, filterService)"
            [valuePrimitive]="true"
            [textField]="'Name'"
            [valueField]="'Id'"
          >
          </kendo-multiselect>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        *ngFor="let question of filteredQuestions; trackBy: trackByQuestion"
        [title]="question.QuestionName"
        [field]="question.QuestionTitle"
        [filterable]="false"
        [sortable]="false"
        width="80"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <app-template-link-copy-wrapper
            [href]="
              originUrl +
              '/#/activity/qa/' +
              dataItem?.fkIncident +
              '/quality' +
              (filter.TemplateId ? '?templateId=' + filter.TemplateId : '')
            "
            [isStatic]="true"
          >
            <ng-container *ngIf="isLongStringAnswer(question, dataItem); else defaultAnswer">
              <button type="button" class="qa-info-button" (click)="openAnswerModal(question, dataItem, $event)">
                <i class="fa fa-file-text-o" aria-hidden="true"></i>
              </button>
            </ng-container>

            <ng-template #defaultAnswer>
              <span
                [class.activity-alarm]="getQuestionAnswer(question, dataItem) === 'No'"
                [class.activity-success]="getQuestionAnswer(question, dataItem) === 'Yes'"
              >
                {{ getAnswerText(question, dataItem) }}
              </span>
            </ng-template>
          </app-template-link-copy-wrapper>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>

<div class="modal fade" bsModal #answerModal="bs-modal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header clearfix">
        <h4 class="modal-title pull-left">{{ answerModalTitle }}</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeAnswerModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{ answerModalText }}
      </div>
      <div class="modal-footer">
        <button class="button" (click)="closeAnswerModal()">Close</button>
      </div>
    </div>
  </div>
</div>
